import parseUtcDate from 'utils/parseUtcDate';

export default function compareDateToToday(date: string) {
  return parseUtcDate(date) >= new Date();
}
